module.exports = __webpack_public_path__ + "static/8-76d0ef8b3a1c85d0c74afc99a319fff8.jpg";